export default __webpack_public_path__ + "static/media/onboard_new_customers_loop.b0baba61.gif";